import { Logger } from '@hawtiosrc/core/logging'

export const pluginId = 'diagnostics'
export const pluginName = 'hawtio-diagnostics'
export const pluginPath = '/diagnostics'
export const log = Logger.get(pluginName)
